import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { graphql } from 'gatsby';

import { useDualToneCenteredTextData } from './hooks';

import { RichText } from 'components/Prismic';
import { Normalize } from 'utils/types';

export type TDualToneCenteredTextSection =
  Normalize<Queries.SolutionDesktopDualToneCenteredTextData_PrismicSolutionDataDesktopSolutionDualToneCenteredText_Fragment>;

const Container = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  height: 139.625rem;
`;

const TitleContainer = styled.div`
  ${({ theme: { colors } }) => css`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background-color: ${colors.black};
    padding-bottom: 5rem;
  `}
`;

const Title = styled(RichText)`
  ${({ theme: { colors, tp } }) => css`
    display: flex;
    flex-direction: column;

    & > h2 {
      text-align: center;
      line-height: 0.965;
      letter-spacing: -0.04em;
      color: ${colors.primary};
      font-size: 9rem;

      ${tp.useFont(fonts => fonts.Switzer.light)};
    }
  `}
`;

const DescriptionContainer = styled.div`
  ${({ theme: { colors } }) => css`
    background-color: ${colors.backgroundDark};
    padding-top: 5rem;
  `}
`;

const Description = styled(RichText)`
  ${({ theme: { colors, tp } }) => css`
    display: flex;
    position: relative;
    justify-content: center;

    & > p {
      text-align: center;
      line-height: 1.2;
      color: ${colors.white};
      font-size: 2.75rem;

      ${tp.useFont(fonts => fonts.Switzer.light)};
    }
  `}
`;

const DualToneCenteredTextSection: React.FC<TDualToneCenteredTextSection> = sliceData => {
  const { title, description } = useDualToneCenteredTextData(sliceData);

  return (
    <Container>
      <TitleContainer>
        <Title render={title} />
      </TitleContainer>
      <DescriptionContainer>
        <Description render={description} />
      </DescriptionContainer>
    </Container>
  );
};

export const desktopDualToneCenteredTextFragment = graphql`
  fragment SolutionDesktopDualToneCenteredTextData on PrismicSolutionDataDesktopSlicesType {
    ... on PrismicSolutionDataDesktopSolutionDualToneCenteredText {
      slice_type

      primary {
        solution_dual_tone_centered_text_title {
          richText
        }
        solution_dual_tone_centered_text_description {
          richText
        }
      }
    }
  }
`;

export default DualToneCenteredTextSection;
